import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignUpFormContainerComponent } from './sign-up-form-container.component';

const routes: Routes = [
  {
    path: '',
    component: SignUpFormContainerComponent,
    pathMatch: 'full',
    data: {
      isSignUp: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SignupForgotPasswordRoutingModule {
  constructor() {}
}
